import { render, staticRenderFns } from "./IncidentsTab.vue?vue&type=template&id=59c259be&scoped=true"
import script from "./IncidentsTab.vue?vue&type=script&lang=ts"
export * from "./IncidentsTab.vue?vue&type=script&lang=ts"
import style0 from "./IncidentsTab.vue?vue&type=style&index=0&id=59c259be&prod&lang=scss"
import style1 from "./IncidentsTab.vue?vue&type=style&index=1&id=59c259be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c259be",
  null
  
)

export default component.exports